import React, { useState, useEffect } from "react";
import CoachLayout from "../common/CoachLayout";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import { useNavigate, useParams, Link } from "react-router-dom";
import { CoachHeader } from "../common/CoachHeader";
import API_URL from "../../api/API";

export const CoachRunrocketTrainingWeeks = () => {
  const { coach } = useCoachAuthContext();
  const navigate = useNavigate();
  const { template_id } = useParams();

  const [openIndex, setOpenIndex] = useState(null); // Accordion state
  const [weeks, setWeeks] = useState([]); // Store weeks data
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  // Toggle accordion logic
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Fetch training data from the API
  const fetchTrainingData = async () => {
    try {
      const response = await fetch(`${API_URL.GET_COACH_RUNROCKET_TRAINING_TEMPLATE_FRONT_WEEKS}${template_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${coach.token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch training data");
      }
      const data = await response.json();
      console.log(data);
      setWeeks(data); // Set the weeks data
      setIsLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      setError(error.message); // Handle errors
      setIsLoading(false); // Set loading to false in case of error
    }
  };

  // Fetch data when the component mounts
  useEffect(() => {
    fetchTrainingData();
  }, [template_id, coach.token]); // Re-fetch if template_id or token changes

  return (
    <CoachLayout>
      <div className="bg-[#f6f6f6] h-full">
        <div className="bg-white">
          <CoachHeader />
        </div>
        <div className="relative h-full bg-[#f6f6f6] pb-5 overflow-y-auto">
          <div className="bg-[#F6F6F6]">
            <div className="w-full max-w-2xl mx-auto flex flex-row justify-between gap-5 px-10 py-[19px]">
              <span onClick={() => navigate("/coach/tools/runrocket/test/result")} className="text-base font-normal pb-[4px] text-[#a5a5a5] cursor-pointer">
                Test
              </span>
              <span className="text-base font-normal pb-[4px] text-black border-b border-black ">
                Train
              </span>
              <span onClick={() => navigate("/coach/tools/runrocket/performance/" + template_id)} className="text-base font-normal pb-[4px] text-[#a5a5a5] cursor-pointer">
                Performance
              </span>
            </div>
          </div>

          <div className={`w-full max-w-2xl mx-auto py-[15px]`}>
            {isLoading ? (
              <div>Loading training weeks...</div>
            ) : error ? (
              <div className="text-red-500">{error}</div>
            ) : (
              weeks.map((week, index) => (
                <div key={index} className={`${openIndex === index && "!border-0 bg-[#ECECEC]"} py-[15px] px-5 border-b border-black/20 last:border-b last:border-black/20 first:border-b first:border-black/20 last:pb-[15px]`}>
                  {/* Accordion button */}
                  <button className="w-full flex justify-between items-center gap-5 text-black text-base font-normal" onClick={() => toggleAccordion(index)}>
                    <p>{week.week_number}</p>
                    <span className={`transform transition-transform ${openIndex === index ? "rotate-180" : ""}`}>
                      <ArrowD />
                    </span>
                  </button>
                  {/* Inner items */}
                  {openIndex === index && (
                    <div className="p-[0px_0px_0px_15px]">
                      {week.days.map((day, i) => (
                        <div key={i} className="p-[15px_0px] flex justify-between items-center border-b border-black/20 last:border-b-0 last:!pb-0">
                          <Link to={`/coach/tools/runrocket/training/week-day/${week.week_number + " => " + day.day}/${day._id}`}  className={`text-black text-base font-normal`}>
                            {day.day}
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </CoachLayout>
  );
};

const ArrowD = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
    <path d="M13 1L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
